export class ArquivoConfiguracaoDiagnosticoFinal {
    nome: string = "";
    tamanho: number = 0;

    constructor(model?: ArquivoConfiguracaoDiagnosticoFinal) {
        if (!model) {
            return;
        }

        this.nome = model.nome;
        this.tamanho = model.tamanho;
    }
}

export class ConfiguracaoDiagnosticoFinal implements Shared.IEntity {
    id: number = 0;
    avaliadorId: number = 0;
    diagnosticoId: number = 0;
    organizacaoId: number = 0;
    tipoAvaliacaoId: number = 0;
    texto: string = "";
    capa: ArquivoConfiguracaoDiagnosticoFinal = new ArquivoConfiguracaoDiagnosticoFinal();

    constructor(model?: ConfiguracaoDiagnosticoFinal) {
        if (!model) {
            return;
        }

        this.id = model.id;
        this.avaliadorId = model.avaliadorId;
        this.diagnosticoId = model.diagnosticoId;
        this.organizacaoId = model.organizacaoId;
        this.tipoAvaliacaoId = model.tipoAvaliacaoId;
        this.texto = model.texto;
        this.capa = new ArquivoConfiguracaoDiagnosticoFinal(model.capa);
    }
}
